import * as Styled from "./styles";
import { FunctionComponent } from "react";

const content = (
  <span>
    By inscribing your mark as a representation of your signature (the “E-Signature”) using a keypad, mouse, or other
    device, and by clicking the “I Agree” button, you confirm you agree to and accept the following: 1) the account
    transfer electronically; 2) the associated{" "}
    <a href="https://manifest.helpscoutdocs.com/article/95-authorization-agreement" target="_blank" rel="noreferrer">
      Authorization
    </a>
    ; 3) you agree that your E-Signature has the same legal effect as your handwritten signature, and no certification
    authority or third-party verification is required to validate your E-Signature, and the absence of such verification
    does not affect the validity or enforceability of any resulting contract among the relevant parties; 4) you
    represent that you are authorized to provide this E-Signature in connection with your account with Manifest; and 5)
    you acknowledge and consent that, to facilitate your account transfer, Manifest may securely transmit certain
    personally identifiable information (PII)—such as your name, contact details, and account identifiers—from its
    platform to your existing account(s). Such data transfer will occur solely for the purpose of completing your
    transaction and will be handled in accordance with Manifest’s{" "}
    <a href="https://manifest.helpscoutdocs.com/article/88-privacy-policy" target="_blank" rel="noreferrer">
      Privacy Policy
    </a>
    . Your plan or account provider may charge fees for this transfer.{" "}
    <a href="https://manifest.helpscoutdocs.com/article/197-fee-disclosure" target="_blank" rel="noreferrer">
      Learn more
    </a>
    .
  </span>
);
const futuremoneyContent = (fullName?: string) => (
  <>
    I {fullName ? `, ${fullName}, ` : ""} verify that I have reviewed and accept the agreements and disclosures for my
    account. I acknowledge that I will be providing an electronic signature to open my account. I understand that the
    Altruist Financial LLC Customer Agreement contains a predispute arbitration clause in Section 27. I agree and
    acknowledge Futuremoney's{" "}
    <a href="https://www.futuremoney.co/legal-privacy" target="_blank" rel="noreferrer">
      Terms and Conditions
    </a>
    ,{" "}
    <a
      href="https://legal.futuremoney.co/FutureMoney+RIA+-+Investment+Management+Agreement.pdf"
      target="_blank"
      rel="noreferrer"
    >
      Investment Management Agreement
    </a>
    ,{" "}
    <a href="https://altruist.com/legal/" target="_blank" rel="noreferrer">
      Altruist customer agreements and disclosures
    </a>
    ,{" "}
    <a href="https://altruist.com/legal/" target="_blank" rel="noreferrer">
      Altruist Roth Individual Retirement Custodial Account Agreement
    </a>
    ,{" "}
    <a href="https://altruist.com/legal/" target="_blank" rel="noreferrer">
      Altruist Electronic Delivery Consent Agreement
    </a>
    , and I acknowledge my advisor's disclosures (
    <a href="https://reports.adviserinfo.sec.gov/reports/ADV/329835/PDF/329835.pdf" target="_blank" rel="noreferrer">
      Part 1
    </a>
    ,{" "}
    <a
      href="https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=969457"
      target="_blank"
      rel="noreferrer"
    >
      2A
    </a>
    ,{" "}
    <a href="https://reports.adviserinfo.sec.gov/crs/crs_329835.pdf" target="_blank" rel="noreferrer">
      3
    </a>
    ). I agree to participate in the Fully Paid Lending Program, which provides the opportunity to earn additional
    monthly income on stock and ETF positions I already own. I opt-in to the dividend reinvestment program ("DRIP") for
    stocks and ETFs (mutual funds are enrolled in the DRIP by default). I agree to participate in the Bank Sweep
    Program, which enables my cash balances to earn interest while awaiting investment, through FDIC-insured deposits at{" "}
    <a
      href="https://altruist.com/legal/altruist-financial-llc-participating-bank-list/"
      target="_blank"
      rel="noreferrer"
    >
      partner banks
    </a>
    .
    <br />
    <br />
    I certify, under penalties of perjury, that the number shown on this application is my correct Taxpayer
    Identification Number, I am a U.S. person and FATCA reporting does not apply.
    <br />
    <br />
    The Internal Revenue Service does not require your consent to any provision of this document other than the
    certifications required to avoid backup withholding.
  </>
);

export type LegalDisclaimerProps = {
  scrollable?: boolean;
  hasTermsAgreed?: boolean;
  toggleTermsAgreement?: (e: boolean) => void;
  isFuturemoney: boolean;
  fullName?: string;
};

const LegalDisclaimer: FunctionComponent<LegalDisclaimerProps> = ({
  isFuturemoney,
  fullName,
}: LegalDisclaimerProps) => {
  return (
    <Styled.LegalDisclaimerContainer>
      <Styled.CustomScrollbar>
        {content}
        <br />
        <br />
        {isFuturemoney && futuremoneyContent(fullName)}
      </Styled.CustomScrollbar>
    </Styled.LegalDisclaimerContainer>
  );
};

export default LegalDisclaimer;
